import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function accountHistoryReducer(
  state = initialState.accountHistory,
  action
) {
  switch (action.type) {
    case types.LOAD_ACCOUNT_HISTORY_SUCCESS:
      return action.accountHistory;
    case types.UNLOAD_ACCOUNT_HISTORY_SUCCESS:
      return action.accountHistory;
    default:
      return state;
  }
}
